import {Form, FormControlProps} from "react-bootstrap";
import React from "react";

type DebouncedInputProps = {
    value: string | number
    onChange: (value: string | number) => void
    debounce?: number,
    placeholder?: string
} & Omit<FormControlProps, "onChange">;

// A debounced input react component
export default function DebouncedInput({value: initialValue, onChange, debounce = 500, placeholder, ...props}: DebouncedInputProps) {
    const [value, setValue] = React.useState(initialValue);
    const [initialLoading, setInitialLoading] = React.useState(true);

    React.useEffect(() => {
        setValue(initialValue);
    }, [initialValue]);

    React.useEffect(() => {
        if (initialLoading) {
            setInitialLoading(false);
            return;
        }
        const timeout = setTimeout(() => {
            onChange(value);
        }, debounce);

        return () => clearTimeout(timeout);
    }, [value]);

    return (
        <Form.Control {...props} value={value} onChange={e => setValue(e.target.value)} placeholder={placeholder}/>
    );
}
